import { useCallback } from 'react';

import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';

export const useIOSLiveActivities = () => {
  const startActivityFn = useCallback(
    (_serverOrder: IServerOrder | IHistoricalOrder, _showImHere: boolean) => {},
    []
  );

  return {
    startActivity: startActivityFn,
  };
};
